import { VehicleBuyInStatus } from "@/api-schema-enums";

export const VEHICLE_BUY_IN_STATUS_TRANSLATIONS = {
  [VehicleBuyInStatus.Unknown]: "fab:VehicleBuyInStatus.Unknown",
  [VehicleBuyInStatus.CreatingContract]: "fab:VehicleBuyInStatus.CreatingContract",
  [VehicleBuyInStatus.ContractCreated]: "fab:VehicleBuyInStatus.ContractCreated",
  [VehicleBuyInStatus.SendingContract]: "fab:VehicleBuyInStatus.SendingContract",
  [VehicleBuyInStatus.ContractSent]: "fab:VehicleBuyInStatus.ContractSent",
  [VehicleBuyInStatus.CancellingContract]: "fab:VehicleBuyInStatus.CancellingContract",
  [VehicleBuyInStatus.ContractCancellationFailed]: "fab:VehicleBuyInStatus.ContractCancellationFailed",
  [VehicleBuyInStatus.ContractCompleted]: "fab:VehicleBuyInStatus.ContractCompleted",
  [VehicleBuyInStatus.Completed]: "fab:VehicleBuyInStatus.Completed",
  [VehicleBuyInStatus.V1SyncFailed]: "fab:VehicleBuyInStatus.V1SyncFailed",
  [VehicleBuyInStatus.Failed]: "fab:VehicleBuyInStatus.Failed",
  [VehicleBuyInStatus.ContractDeclined]: "fab:VehicleBuyInStatus.ContractDeclined",
  [VehicleBuyInStatus.ContractCancelled]: "fab:VehicleBuyInStatus.ContractCancelled",
  [VehicleBuyInStatus.ContractExpired]: "fab:VehicleBuyInStatus.ContractExpired",
} as const satisfies Record<VehicleBuyInStatus, string>;
